// extracted by mini-css-extract-plugin
export default {"box":"TextForm_box__u1hWQ","myLable":"TextForm_myLable__ptW9A","radius":"TextForm_radius__GnOi-","psize":"TextForm_psize__IR9XQ"};